<template>
  <n-editor-button
    icon="drag-handle"
    :aria-label="$t('general.dragHandle')"
    :class="hidden && 'hide'"
    @click="$emit('click', $event)"
    @touchstart="$emit('click')"
    :disabled="hidden && !focusable"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import NEditorButton from '@/modules/global/components/core/NEditorButton.vue'
@Component({
  components: { NEditorButton }
})
export default class DragHandle extends Vue {
  @Prop({ type: Boolean }) hidden?: boolean
  /** Hidden but still a Tab stop: the owner shows it once it has keyboard focus */
  @Prop({ type: Boolean }) focusable?: boolean
}
</script>
